import { Observable } from 'rxjs';
import { getConfigurations } from 'utils/api/queries/wcm';

export class GetConfigService {
	public static getConfigurations(): Observable<{ response: types.Configurations }> {
		return getConfigurations().call();
	}
}

export default GetConfigService;
